import { IPersonaProps, Persona } from '@fluentui/react/lib/Persona';

export interface IPPersonaProps extends IPersonaProps {}
export { PersonaPresence as IPPersonaPresence, PersonaSize as IPPersonaSize } from '@fluentui/react/lib/Persona';

export const IPPersona = (props: IPPersonaProps) => {
  return <Persona {...props} />;
};
